/** API route map: URLS.Controller.Alerts */
export const Alerts = {
      Name: 'EmployeeAlert/',
      GetAlerts: 'get-all-alerts',
      GetEmployeeAlerts: 'get-employee-alerts',
      AddSignature: 'add-signature',
      AddConsent: 'add-consent',
      AddAcknowledgement: 'add-acknowledgement',
      GetEmployeeInfo: 'get-employee-placeholder',
      GetClientInfo: 'get-client-placeholder',
      SignAlertDocument: 'sign-alert-document',
      RetryAlertDocument: 'retry-alert-document',
};
